<template>
  <div style="color: #b1b1b2;">Не заполняется</div>
</template>

<script>

export default {
  name: "quality-card-plan-view",
}
</script>